import useResource from "hooks/resources"
import { useAccountAlias } from "resources/account"

export interface SolutionsCount {
  generic?: number
  sigma?: number
  licensedSkills?: number
  proprietarySkills?: number
}

// Load-only: the Solutions / Agentic Tasks gating selectors read the resource straight out of
// `global.data`, and — like the `passthrough` descriptor this replaces — it never gates rendering.
export function useSolutionsCount(): void {
  const account = useAccountAlias()

  // Empty path arg: useResource only walks it on its GraphQL branch, and a REST payload has no sub-path.
  useResource<SolutionsCount>({
    resource: "solutionsCount",
    url: () => account ? `/api/${account}/solutions/count` : null,
  }, [])
}
